import Backbone from "pages/common/lib/backbone-helpers";
import _ from "underscore";

var DVRSectionModel = Backbone.Model.extend({
    idAttribute: `startTimestamp`,

    defaults: {
        startTimeOffset: 0,
        endTimeOffset: 0,
        type: `hls`,
        croppingProperty: `pad`
    },

    parse: function (response) {
        if (_.isArray(response.contentSections)) {
            return response.contentSections[0];
        } else {
            if (_.isNumber(response.startTimeOffset)) {
                response.startTimeOffsetInSeconds =
                    response.startTimeOffset / 1000;
            }

            if (_.isNumber(response.endTimeOffset)) {
                response.endTimeOffsetInSeconds = response.endTimeOffset / 1000;
            }

            return response;
        }
    },

    initialize: function () {
        if (!this.has(`playlistUrl`)) {
            this.set(`playlistUrl`, this.get(`getPlaylistUrl`));
        }
    },

    getCurrentTimeUTC: function (time) {
        time = _.isNumber(time) && time >= 0 ? time : 0;
        return this.get(`startTimestamp`) / 1000 + time;
    },

    getCurrentTime: function (time) {
        if (App.Views.trim.timelineStore) {
            var currentTimeUTC = this.getCurrentTimeUTC(time);
            var playlistStart = App.Views.trim.timelineStore.start / 1000;
            return currentTimeUTC - playlistStart;
        } else {
            return 0;
        }
    },

    getTimeRelativeToVideo: function (time) {
        time = _.isNumber(time) && time >= 0 ? time : 0;
        var relativeTime = time - this.get(`startTimestamp`);
        return relativeTime > 0 ? relativeTime / 1000 : 0;
    },

    isLive: function () {
        return (
            this.get(`type`) === `live` && this.get(`endTimestamp`) === Infinity
        );
    },

    getPlaylistUrl() {
        return this.get(`playlistUrl`);
    },

    getPlayableDuration: function () {
        return this.get(`duration`);
    }
});

export default DVRSectionModel;
